module.exports = __webpack_public_path__ + "static/media/brycen5.c98f6461.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen5.gif
// module id = 150
// module chunks = 0